import {FC} from "react";
import InfoIcon from "../../assets/images/infoIcon.svg";
import CrossIcon from "../../assets/images/CrossToast.svg";

interface Props {
    closeToast?: () => void;
    message: string;
}
export const CustomErrorToast: FC<Props> = ({ closeToast, message }) => {
    return (
        <div className="flex items-start rounded-lg px-4 py-3 max-w-md shadow-md">
            <InfoIcon className="w-[14px] h-[14px] mt-[3px]" />
            <p className="text-sm font-medium flex-1">{message}</p>
            <button onClick={closeToast} className="cursor-pointer">
                <CrossIcon className="w-2.5 h-2.5 mt-[5px]"/>
            </button>
        </div>
    );
};